import React from 'preact/compat';
import { JSX } from 'preact';

export default function ImageIcon(props: Omit<JSX.SVGAttributes<SVGSVGElement>, 'viewBox'>) {
    return (
        <svg viewBox='0 0 32 32' {...props}>
            <path d='M32 32v-32h-32v32zM9.778 18.667l4.444 5.351 6.222-8.018 8 10.667h-24.888z' />
        </svg>
    );
}
